import ErrorFormatService from '../../../services/error-format-service';
import {
  GET_PORTFOLIO_GROUP_DATA_SUCCESS, GET_PORTFOLIO_DEAL_EMAIL_CONNECTOR_DATA_SUCCESS, SAVE_PORTFOLIO_GROUP_DATA,
  SAVE_PORTFOLIO_GROUP_DATA_SUCCESS, SAVE_PORTFOLIO_GROUP_DATA_ERROR, RESET_DEAL_CONNECTOR_AUTH_LINK,
  VERIFY_PORTFOLIO_DEAL_EMAIL_CONNECTOR_SUCCESS, DELETE_PORTFOLIO_GROUP_PORTFOLIO_SUCCESS, LOGIN_USER_SUCCESS,
  LOGOUT_USER_SUCCESS, RESET_FORM_ERRORS,
} from '../../../constants/system/actions';

const settingsPortfolioGroupReducer: Reducer = (
  state: ReducerState = {
    portfolioGroupData: null,
    dealConnectorAuthLink: null,
    formErrors: {},
    isFormSaving: false,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case GET_PORTFOLIO_GROUP_DATA_SUCCESS:
      return {
        ...state,
        portfolioGroupData: action.data,
      };
    case SAVE_PORTFOLIO_GROUP_DATA:
      return {
        ...state,
        formErrors: {},
        isFormSaving: true,
      };
    case SAVE_PORTFOLIO_GROUP_DATA_SUCCESS:
      return {
        ...state,
        portfolioGroupData: action.data.portfolioGroupData,
        formErrors: {},
        isFormSaving: false,
      };
    case SAVE_PORTFOLIO_GROUP_DATA_ERROR:
      if (!action.error) {
        return {
          ...state,
          isFormSaving: false,
        };
      }

      return {
        ...state,
        formErrors: ErrorFormatService.isFormError(action.error)
          ? ErrorFormatService.formatGraphQLErrors({ ...action.error })
          : ErrorFormatService.formatGraphQLMainError({ ...action.error }),
        isFormSaving: false,
      };
    case DELETE_PORTFOLIO_GROUP_PORTFOLIO_SUCCESS:
    case VERIFY_PORTFOLIO_DEAL_EMAIL_CONNECTOR_SUCCESS:
      return {
        ...state,
        portfolioGroupData: action.data.portfolioGroupData,
      };
    case GET_PORTFOLIO_DEAL_EMAIL_CONNECTOR_DATA_SUCCESS:
      return {
        ...state,
        dealConnectorAuthLink: action.data.authLink,
      };
    case RESET_DEAL_CONNECTOR_AUTH_LINK:
      return {
        ...state,
        dealConnectorAuthLink: null,
      };
    case RESET_FORM_ERRORS:
      return {
        ...state,
        formErrors: {},
      };
    case LOGIN_USER_SUCCESS:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        portfolioGroupData: null,
        dealConnectorAuthLink: null,
        formErrors: {},
        isFormSaving: false,
      };
    default:
      return state;
  }
};

export default settingsPortfolioGroupReducer;
